import { useEffect } from "react";
import { socket } from "../socket/socketClient";

export default function useMeetingRealtime({ meetingId, onFieldUpdate }) {
	useEffect(() => {
		if (!meetingId) return;

		// const room = `meeting_${meetingId}`;

		// console.log("🔌 Joining room:", room);
		socket.emit("join_meeting_room", meetingId);

		const handleUpdate = ({ field, value }) => {
			// console.log("🟣 Campo actualizado remotamente:", field, value);
			onFieldUpdate?.(field, value);
		};
		socket
			.off("meeting_field_updated")
			.on("meeting_field_updated", handleUpdate);

		const handleInitialState = (data) => {
			// console.log("📦 Estado inicial de la reunión recibido:", data);
			for (const [field, value] of Object.entries(data)) {
				onFieldUpdate?.(field, value);
			}
		};
		socket
			.off("meeting_state_init")
			.on("meeting_state_init", handleInitialState);

		socket.emit("request_meeting_status", meetingId);

		return () => {
			// console.log("🚪 Leaving room:", room);
			socket.emit("leave_meeting_room", meetingId);
			socket.off("meeting_field_updated", handleUpdate);
			socket.off("meeting_state_init", handleInitialState);
		};
	}, [meetingId, onFieldUpdate]);
}
